export default class CompanyUidClient {
    // eslint-disable-next-line class-methods-use-this
    async search(searchTerm) {
        const url = searchTerm ? `/api/search-company-uid/${searchTerm}` : '/api/search-company-uid';
        const response = await fetch(url, { method: 'POST' });

        return response.json();
    }
}
